module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/selo-sem-luz-57997165c8c3b46c1933756a38fffd1d.png";